import React from 'react'

class Input extends React.Component {

    render() {
        const { className, id, placeholder, onChange, type, error, disabled, autofocus } = this.props

        return (
            <div
                style={{ display: 'flex', flexDirection: 'column', width: '100%', marginBottom: this.props.marginBottom ? 12 : 0 }}
            >
                <input
                    autofocus
                    class={error ? `${className} border-red-500 border-2 text-red-700` : className}
                    onChange={onChange}
                    id={id}
                    placeholder={placeholder}
                    type={type}
                    disabled={disabled}
                />
                {error &&
                    <p
                        class='rounded-md bg-red-600 p-1.5 bg-white text-sm font-medium text-white text-xs italic'
                        style={{ position: 'absolute', bottom: -40, left: 0 }}
                    >
                        {error}
                    </p>
                }
            </div>
        )
    }
}

export default Input